import { defineComponent, h, PropType } from 'vue'

import { Pie } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  ArcElement,
  CategoryScale,
  Plugin
} from 'chart.js'


ChartJS.register(Title, Tooltip, ArcElement, CategoryScale)

export default defineComponent({
  name: 'PieChart',
  
  components: {
    Pie
  },
  props: {
    chartId: {
      type: String,
      default: 'pie-chart'
    },
    width: {
      type: Number,
      default: 350
    },
    height: {
      type: Number,
      default: 350
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object as PropType<Partial<CSSStyleDeclaration>>
    },
    plugins: {
      type: Array as PropType<Plugin<'pie'>[]>,
      default: () => undefined
    },
    lables:{
      type: Array as PropType<Array<string>>,
    },
    backgroundColors:{
      type: Array as PropType<Array<string>>,
    },
    numbers: {
      type: Array as PropType<Array<number>>,
        default: () => []
    }
  },
  setup(props) {
    const chartData = {
      labels: props.lables,
      datasets: [
        {
          backgroundColor: props.backgroundColors,
          data: props.numbers
        }
      ]
    }

    const chartOptions = {
      responsive: false,
      maintainAspectRatio: false,
      legend:{
        display:false,
        rtl: true,
        onClick: function (e:any) {
            alert("fdf")
                  },
        labels: {
            padding: 15,
            usePointStyle:true
        }
      }
      


    }

    return () =>
      h(Pie, {
        chartData,
        chartOptions,
        chartId: props.chartId,
        width: props.width,
        height: props.height,
        cssClasses: props.cssClasses,
        styles: props.styles,
        plugins: props.plugins
      })
  }
})
